"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _jodit = require("jodit");

var _aColorPicker = require("a-color-picker");

/**
 * Adapted from an old Jodit example: https://xdan.github.io/jodit/examples/color-picker.html
 *
 * @param {object} localeText `{ button: 'Button text', title: 'Dialog title' }`
 * @returns {object} A Jodit plugin initializer
 * @example
 * ```
 * const picker = customColorPicker({ button: 'Click me', title: 'Pick a color' });
 * Jodit.plugins.add('customColorPicker', picker);
 * ```
 */
var _default = (localeText, showColor) => {
  var ref = (0, _react.useRef)({
    locale: null,
    added: false
  });
  (0, _react.useEffect)(() => {
    ref.current.locale = localeText;
  }, [localeText]); // Can't useEffect here; plugins have to be added before the editor is created

  if (!ref.current.added && showColor) {
    if (!(localeText === null || localeText === void 0 ? void 0 : localeText.button) || !(localeText === null || localeText === void 0 ? void 0 : localeText.title)) {
      throw new Error("Missing prop 'colorPickerLocale'. The custom color picker must be given localized text.");
    } // Jodit needs an actual function here; => can't be used as constructors
    // eslint-disable-next-line func-names


    _jodit.Jodit.plugins.add('customColorPicker', function (editor) {
      editor.events.on('afterGenerateColorPicker', (form, extra) => {
        var {
          locale
        } = ref.current;
        var elm = editor.create.fromHTML("<button class=\"jodit-ui-button\">".concat(locale.button, "</button>"));

        _jodit.Jodit.ns.Dom.detach(extra);

        extra.appendChild(elm);
        var selectedColor = null;
        elm.addEventListener('click', () => {
          // On Click - show dialog with color-pciker
          var dialog = _jodit.Jodit.Alert('', locale.title, () => {
            if (!selectedColor) {
              return;
            }
            /*
              If the user clicks into one of the custom picker's text fields,
              Jodit's selection is lost. Jodit saves the selection internally on
              blur, so we just have to manually restore it.
            */


            editor.s.focus();
            editor.s.restore();
            var style = new _jodit.Jodit.ns.CommitStyle({
              style: {
                color: _jodit.Jodit.ns.Helpers.colorToHex(selectedColor)
              }
            });
            style.apply(editor);
          }); // Init custom color picker for dialog's content element


          (0, _aColorPicker.from)(dialog.dialogbox_content.firstChild).on('change', (picker, color) => {
            selectedColor = color;
          });
        });
      });
    });

    ref.current.added = true;
  }
};

exports.default = _default;